module.exports = "/img/7.a1fd9e.webp";